import styled from 'styled-components';
import BaseButton from 'shared/ui/Button';

const Button = styled(BaseButton)`
  width: max-content;
  margin: 16px 0 0;
  border-radius: 0;
`;
Button.displayName = 'Button';

export default Button;
